module.exports = __webpack_public_path__ + "static/pay-later-2-2b3f546a852686e75e6a36ae3446fc8a.svg";